<template>
    <v-container class="pa-0" fluid>
        <v-row>
            <v-col class="pa-1">
                    <!-- sizes="(max-width: 600px) 100vw,
                            (max-width: 960px) 100vw,
                            100vw"


                    :srcset="`${require(`@/assets/img/reinforcement/${xs}`)} 452w,
                    ${require(`@/assets/img/reinforcement/${md}`)} 800w
                    ${require(`@/assets/img/reinforcement/${lg}`)} 1308w`"

                    :srcset="`${require(`@/assets/img/reinforcement/${xs}`)} 2x,
                    ${require(`@/assets/img/reinforcement/${md}`)} 1.5x,
                    ${require(`@/assets/img/reinforcement/${lg}`)}`"

                    :src="require(`@/assets/img/reinforcement/${lg}`)" -->
                <v-img
                    :src="require(`@/assets/img/reinforcement/${md}`)"
                    :lazy-src="require(`@/assets/img/reinforcement/${xs}`)"
                    :srcset="`${require(`@/assets/img/reinforcement/${xs}`)} 400w,
                    ${require(`@/assets/img/reinforcement/${sm}`)} 800w,
                    ${require(`@/assets/img/reinforcement/${md}`)} 1200w,
                    ${require(`@/assets/img/reinforcement/${lg}`)} 1600w,
                    ${require(`@/assets/img/reinforcement/${xl}`)} 2000w`"
                    sizes="(max-width: 600px) 400px,
                            (max-width: 960px) 800px,
                            (max-width: 1264px) 1200px,
                            (max-width: 1904px) 1600px,
                            2000px)"
                    height="130"
                    gradient="rgba(0, 0, 0, .7) 75%, rgba(255, 255, 255, .1)"
                    class="d-flex justify-center align-center"
                >
                <v-row class="d-flex justify-center align-center">
                    <v-col cols="11" sm="9">
                        <p class="text-subtitle-1 font-weight-light text-center white--text">
                            Play all the music you love to play, the same way you're used to
                            playing it, but with every note on the fretboard tuned precisely.
                        </p>
                    </v-col>
                </v-row>
                </v-img>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  data() {
    return {
      xs: 'xs.jpg',
      sm: 'sm.jpg',
      md: 'md.jpg',
      lg: 'lg.jpg',
      xl: 'xl.jpg',
      default: 'md',
    };
  },
};
</script>

<style>
</style>
